import { GatePass } from './../../_models/gate_pass';

import { AuthService } from '../../_services/auth.service';
import { Component, OnInit,Input} from '@angular/core';
declare var $ : any;

@Component({
  selector: 'app-guardian-main-area',
  templateUrl: './guardian-main-area.component.html',
  styleUrls: ['./guardian-main-area.component.css']
})

export class GuardianMainAreaComponent implements OnInit {
  @Input() guardian=undefined
  gatePass:GatePass = new GatePass()
  constructor(public authService:AuthService) { }

  ngOnInit(): void {

    this.authService.gatePass.subscribe(
      gatePass=>{
        this.gatePass = gatePass
      }
    )
  }
  addStudentRegistrationPopup(){
    $("#regStudentModal").modal("show")
  }
}
